import { useSession } from '../session'
import { canCapture } from './capture'

/** Whether dictation is offered: this server takes it and this browser can record audio. */
export function useVoiceAvailable(): boolean {
  const { me } = useSession()
  return (me?.voice.enabled ?? false) && canCapture()
}
